module.exports = __webpack_public_path__ + "img/tree-04-e-trunk.34a498b1.png";